export default "__VITE_ASSET__CrAI2YsI__"